<template>
  <base-dialog @cancel="cancelDialog" :width="1200">
    <div slot="header">{{ $t('report.report_preview') }}</div>
    <div slot="body" class="pdf-preview-body">
      <div v-if="pdfUrl" class="pdf-preview-wrapper">
        <iframe :src="pdfUrl" class="pdf-iframe" frameborder="0" />
      </div>
      <div v-else class="empty-preview">
        <a-empty :description="$t('report.no_preview_content')" />
      </div>
    </div>
    <div slot="footer">
      <a-button @click="handleExport" type="primary" :loading="exporting">
        {{ $t('common.export_pdf') }}
      </a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.ok') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'ReportPdfPreviewDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      pdfUrl: null,
      exporting: false,
    }
  },
  mounted () {
    this.initPdf()
  },
  beforeDestroy () {
    this.cleanupPdf()
  },
  methods: {
    initPdf () {
      const { pdfContent, filename } = this.params.data || {}
      if (!pdfContent) {
        return
      }
      // 处理 base64 数据
      let base64Data = pdfContent
      // 如果包含 data:application/pdf;base64, 前缀，需要移除
      if (base64Data.includes(',')) {
        base64Data = base64Data.split(',')[1]
      }
      // 创建 Blob URL
      try {
        const binaryString = atob(base64Data)
        const bytes = new Uint8Array(binaryString.length)
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }
        const blob = new Blob([bytes], { type: 'application/pdf' })
        this.pdfUrl = URL.createObjectURL(blob)
        this.filename = filename || 'report.pdf'
      } catch (error) {
        console.error('Failed to load PDF:', error)
        this.$message.error(this.$t('report.no_preview_content'))
      }
    },
    cleanupPdf () {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl)
        this.pdfUrl = null
      }
    },
    handleExport () {
      const { pdfContent, filename } = this.params.data || {}
      if (!pdfContent) {
        this.$message.warning(this.$t('report.no_preview_content'))
        return
      }
      this.exporting = true
      try {
        // 处理 base64 数据
        let base64Data = pdfContent
        if (base64Data.includes(',')) {
          base64Data = base64Data.split(',')[1]
        }
        // 转换为 Blob
        const binaryString = atob(base64Data)
        const bytes = new Uint8Array(binaryString.length)
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }
        const blob = new Blob([bytes], { type: 'application/pdf' })
        // 创建下载链接
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename || 'report.pdf'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.$message.success(this.$t('common.success'))
      } catch (error) {
        console.error('Failed to export PDF:', error)
        this.$message.error(this.$t('common.error'))
      } finally {
        this.exporting = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.pdf-preview-body {
  background: #f5f5f5;
  padding: 0;
  height: 80vh;
  display: flex;
  flex-direction: column;
}

.pdf-preview-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #525252;
  padding: 20px;
  overflow: hidden;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: #fff;
}

.empty-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}
</style>
